import classNames from "classnames";
import { VirtListRowProps } from "../list/BaseList";
import * as listStyles from "../list/VirtList.less";

export function getRowStyle<ItemType>(props: VirtListRowProps<ItemType>, additionalClasses: string = "") {
    const { isFocused, index, item, items, getItemClassName, isItemDisabled } = props;

    return classNames(
        listStyles.row,
        isFocused && listStyles.focused,
        getItemClassName?.(item, items),
        isItemDisabled?.(item) && listStyles.readonly,
        isFirstItem(index) && listStyles.first_list_item,
        isLastItem(items, index) && listStyles.last_list_item,
        additionalClasses
    );
}

const addPaddingIf = (condition: boolean): number => (condition ? 8 : 0);
const isFirstItem = (index: number): boolean => index === 0;
const isLastItem = (items: any[], index: number): boolean => index === items.length - 1;

export const getListItemHeight = <TItem extends {}>(_: TItem, index: number, items: TItem[]): number => {
    const topPadding = addPaddingIf(isFirstItem(index));
    const bottomPadding = addPaddingIf(isLastItem(items, index));

    return 36 + topPadding + bottomPadding;
};
